<form
  [formGroup]="form"
  (ngSubmit)="onFormSubmit()"
  #formRef="ngForm"
  [canEdit]="[accessRights.ConfigurationOptions_write]"
  [canEdit]="[accessRights.Settings_write]"
>
  <!-- [patchForm]="formValues" -->
  <section class="card mb-3">
    <div class="card-header card-collapse">
      <!-- Header -->
      <h2 class="accordion-header">
        <button
          class="accordion-button"
          type="button"
          [attr.aria-expanded]="isCollapsed ? 'false' : 'true'"
          (click)="isCollapsed = !isCollapsed"
          aria-controls="other-panel"
        >
          <span class="fs-3"> {{ 'general.other' | translate }}</span>

          <i
            class="fa fa-fw"
            [ngClass]="isCollapsed ? 'fa-chevron-down' : 'fa-chevron-up'"
            attr.aria-label="{{ 'wcag.toggleSection' | translate }}"
            role="img"
          ></i>
        </button>
      </h2>

      <!-- End Header -->
    </div>

    <div *ngIf="!isCollapsed" class="card-body" id="other-panel">
      <div class="mb-4">
        <label class="form-label">{{ 'general.adminEmail' | translate }}</label>

        <input type="email" class="form-control" formControlName="adminemail" />
      </div>

      <div class="mb-4">
        <label class="form-label">{{
          'general.defaultCountry' | translate
        }}</label>

        <select class="form-select" formControlName="default_country">
          <option [ngValue]="null" selected>
            {{ 'general.select' | translate }}
          </option>
          <option
            *ngFor="let availableCountry of availableCountries"
            [value]="availableCountry.ISO3166CountryCode"
          >
            {{ 'countries.' + availableCountry.ISO3166CountryCode | translate }}
          </option>
        </select>
      </div>

      <div class="mb-4">
        <fieldset>
          <legend class="form-label">{{
            'saleModule.createSaleCancelNotification' | translate
          }}</legend>

          <div class="d-flex">
            <div class="btn-group-segment">
              <input
                type="radio"
                class="btn-check"
                name="createSaleCancelNotification"
                value="{{ true }}"
                id="createSaleCancelNotificationbtnradio1"
                (click)="
                  form.controls['create_sale_cancel_notification'].patchValue(
                    true
                  )
                "
                autocomplete="off"
                [checked]="form.value.create_sale_cancel_notification == '1'"
              />
              <label class="btn" for="createSaleCancelNotificationbtnradio1">
                {{ 'general.yes' | translate }}
              </label>

              <input
                type="radio"
                class="btn-check"
                name="createSaleCancelNotification"
                id="createSaleCancelNotificationbtnradio2"
                value="{{ false }}"
                (click)="
                  form.controls['create_sale_cancel_notification'].patchValue(
                    false
                  )
                "
                autocomplete="off"
                [checked]="form.value.create_sale_cancel_notification == '0'"
              />
              <label class="btn" for="createSaleCancelNotificationbtnradio2">
                {{ 'general.no' | translate }}
              </label>
            </div>
          </div>
        </fieldset>
        <!-- <input
          type="email"
          class="form-control"
          formControlName="create_sale_cancel_notification"
        /> -->
      </div>

      <div class="d-flex justify-content-end pt-3">
        <button
          class="btn btn-primary"
          type="submit"
          [canSee]="[accessRights.Settings_write]"
          [canSee]="[accessRights.ConfigurationOptions_write]"
        >
          {{ 'general.save' | translate }}
        </button>
      </div>
    </div>
  </section>
</form>
